/**
* Header Navigation Primary
*/
function fnNavigationPrimary() {

	/**
	* Scrolling
	*/
	var oBody           = $( 'body' ),
        oHeader         = $( 'aside.primary' ),
        oTrigger        = $( '.menu-trigger' );


	/**
	* Mobile
	*/

	oTrigger.click(function(){

    	$( this ).toggleClass( 'nav-visible' );
    	$( 'nav.mobile' ).toggleClass( 'nav-visible' ).removeClass( 'was-visible' );
    	$( oBody ).toggleClass( 'nav-visible' );
    	$( oHeader ).toggleClass( 'nav-visible' );

    	// Animation destraction
        if ( ! $( this ).hasClass( 'nav-visible' ) ) {
    		$( 'nav.mobile' ).toggleClass( 'was-visible' );
    	}

	});

}
